module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"mainTitle":"Our training","subTitle":"Services available soon."},"fr":{"mainTitle":"Nos formations","subTitle":"Services bientôt disponibles."}}')
  delete Component.options._Ctor
}
